import { createFileRoute } from "@tanstack/react-router"
import { AppLayout } from "src/layouts"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout")({
	component: AppLayout,
})
